module.exports = __webpack_public_path__ + "img/kerun-header.825490dc.png";